import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { from, map } from 'rxjs';
import Swal from 'sweetalert2';
import { AlertService } from './alert.service';
import { LocalStorageService } from './local-storage.service';


@Injectable({ 
    providedIn: 'root'
})

export class HelperService {

    formButtonDisabled: boolean = false;
    
    constructor(
        private translate: TranslateService,
        private datePipe: DatePipe,
        private http: HttpClient,
        private translateService: TranslateService,
        private alertService: AlertService,
        private localStorageService: LocalStorageService
    ){}

    actionConfirmation(msg="") {

        const set_msg = msg !== "" ? msg : 'ALERTS.perform-action'; 
        return Swal.fire({
            title: this.translate.instant('COMMON.confirmation'),
            html: `
                <div class='swal-customs-div'>
                    <h5 class='swal-custom-title'>${this.translate.instant('COMMON.are-you-sure')}</h5>
                    <p class='swal-custom-text'>${this.translate.instant(set_msg)}</p>
                </div>`,
            // text: this.translate.instant('COMMON.are-you-sure') + "<br>" + this.translate.instant(set_msg),
            showCancelButton: true,
            cancelButtonText: `${this.translate.instant('COMMON.close')}`,
            confirmButtonText: this.translate.instant('COMMON.proceed'),
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'cancel-swal-custom btn btn-secondary'
            },
        }).then(result => {
            return result.isConfirmed;
        });
    }

    deleteRecord(): Promise<boolean> {
        return Swal.fire({
          title: this.translate.instant('COMMON.confirmation'),
          html: `
            <div class='swal-customs-div'>
                <h5 class='swal-custom-title'>${this.translate.instant('COMMON.are-you-sure')}</h5>
                <p class='swal-custom-text'>${this.translate.instant('COMMON.wont-recover')}</p>
            </div>`,
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'cancel-swal-custom btn btn-secondary'
          },
          cancelButtonText: `${this.translate.instant('COMMON.close')}`,
          confirmButtonText: this.translate.instant('COMMON.yes-delete')
        }).then(result => {
          return result.isConfirmed;  // Return true if confirmed, false otherwise
        });
    }

    createFormData(formElement: FormGroup | UntypedFormGroup){
        const formData = new FormData();
        Object.keys(formElement.controls).forEach(field => {
            formData.append(field, (formElement.get(field)?.value ?? "") );
        });

        return formData;
    }

    validateAvatar(event){
        const input = event.target as HTMLInputElement;
    
        if (input.files && input.files[0]) {
          const file = input.files[0];
          const maxSizeInMB = 3;
    
          // Validate file type
          const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
          if (!allowedTypes.includes(file.type)) {
            return [false, this.translate.instant('VALIDATION.avatar-type')];
          }
    
          // Validate file size
          if (file.size > maxSizeInMB * 1024 * 1024) {
            return [false, this.translate.instant('VALIDATION.avatar-size')];
          }

          return [true, file];

        }

        return [false, ""];
    }

    formatNumberNL(value: number | string | null | undefined): string {
        if (!value || isNaN(+value)) {
            return '0';
        }
    
        const number = Number(value);
        const hasFraction = number % 1 !== 0;

        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: hasFraction ? 2 : 0,
            maximumFractionDigits: 2,
            useGrouping: true
        };
    
        return new Intl.NumberFormat('nl-NL', options).format(number);
    }

    percentageAmount(amount: number | string | null | undefined, percentage: number | string | null | undefined){
        if (!amount || isNaN(+amount) || !percentage || isNaN(+percentage)) {
            return '0,00';
        }

        var result: any = (+amount / 100) * (+percentage);
        return this.formatNumberNL(result);
    }

    commaSeperatedString(array: string[]) : string {
        if (!Array.isArray(array)) return '-';
        const data = array
                        .map(item => (item ? item.trim() : ''))     // remove whitespace
                        .filter(item => item !== '')  // remove empty values
                        .join(', ')
                        .trim();

        return (data == "" ? "-" : data);
    }

    creatingExport: boolean = false;
    generateExport(downloadUrl, fileTitle){

        const user = this.localStorageService.getItem('currentUser')
        let company = user["company_name"].replace(" - ", "");

        if(this.creatingExport === false){
            this.creatingExport = true;
            this.http.get(downloadUrl, {
                responseType: 'blob',
                withCredentials: true // if you're using Sanctum or cookies
            }).subscribe(blob => {
                const fileName = this.translateService.instant(fileTitle)+" - "+company+'.xlsx';
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(objectUrl); // cleanup
                this.creatingExport = false;
            }, error => {
                const msg = this.translateService.instant("ALERTS.failed-to-download-no-exist");
                this.alertService.triggerAlert(msg, "error");   
                this.creatingExport = false;
            });
        }
    }

    getSmaller(firstNum: number, secondNum: number){
        if(!firstNum)
            return secondNum;
        
        if(!secondNum)
            return firstNum;

        return (+firstNum < +secondNum) ? firstNum : secondNum;
    }
}

